import { WORKEFFY_BASENAME } from './workeffy';

// Designations are managed in effy-fe's job architecture now (see `redirects.js`).
const JOB_ARCHITECTURE_ROUTE = `${WORKEFFY_BASENAME}/admin/job-architecture`;

const DesignationAdminRoutes = {
  DesignationManager: () => JOB_ARCHITECTURE_ROUTE,
  DesignationDetails: (_orgRoleId: string) => JOB_ARCHITECTURE_ROUTE,
};

const routes = {
  ...DesignationAdminRoutes,
};

export default routes;
